import boletaApi from "./boletaApi";

export const registerEmployee = async (body) => {
  try {
    return await boletaApi.post("/registerEmployee", body);
  } catch (error) {
    const { response } = error;
    return response;
  }
};
